var React = require('react');

function Attachment (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m25.488 95c-4.3242 0.097656-8.5078-1.5312-11.629-4.5312-3.0469-3.0703-4.7188-7.2422-4.6406-11.57 0.15234-6.1484 2.7383-11.984 7.1914-16.227l39.59-39.16c5.3789-5.3281 13.469-6 18-1.5 2 2.0234 3.1055 4.7695 3.0586 7.6172-0.074219 3.9258-1.7148 7.6602-4.5586 10.371l-37.398 37c-1.1797 1.1641-3.082 1.1523-4.2461-0.023438-1.1641-1.1797-1.1562-3.082 0.023437-4.2461l37.398-37.051h0.003906c1.6758-1.5781 2.6719-3.75 2.7695-6.0508 0.042969-1.2383-0.42188-2.4453-1.2812-3.3398-2.1992-2.1719-6.5898-1.4883-9.6016 1.4883l-39.539 39.164c-3.3203 3.1211-5.2695 7.4414-5.4102 12-0.082031 2.7188 0.94922 5.3555 2.8516 7.2969 4.6914 4.6289 13.469 3.4805 19.578-2.5703l39.543-39.199c5.1289-5.0781 8.0586-11.59 8.0586-17.871v0.003906c0.12109-4.1992-1.4766-8.2656-4.4219-11.262-7.1484-7-20.41-5.4219-29.559 3.6484l-37.41 37.012c-1.1797 1.1641-3.0781 1.1523-4.2461-0.023438-1.1641-1.1797-1.1523-3.082 0.027344-4.2461l37.41-37.012c11.469-11.359 28.52-13 38-3.6484 4.0703 4.1328 6.3047 9.7305 6.1992 15.531 0 7.8711-3.5781 15.941-9.8398 22.141l-39.539 39.156c-4.3281 4.4141-10.203 6.9609-16.383 7.1016z"}));
}

Attachment.defaultProps = {"width":"100%","height":"100%","version":"1.1","viewBox":"0 0 100 100"};

module.exports = Attachment;

Attachment.default = Attachment;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/assets/attachment.svg
// module id = 373
// module chunks = 0